/**
 * Envelope codes that consume the PaymentMethod. CardCapture must mint a fresh token.
 * BillingTab at tmm-app `b816a8f` does not return `'retry'` for a declined class;
 * the spec names these two codes.
 */
import { ApiError } from '@/api/errors';

const CARD_DECLINED_CODES: readonly string[] = ['CARD_DECLINED', 'INVALID_CARD'];

export function isCardDeclinedCode(err: unknown): boolean {
  if (!(err instanceof ApiError)) return false;
  const code = err.details?.code;
  return typeof code === 'string' && CARD_DECLINED_CODES.includes(code);
}
